// Staff copy for online booking: Administration → Online booking,
// Reception's Book, and the Appointments screen. Change all three languages at once.
import type { Phrase } from '../staffText'

export const booking = {
  // Settings frame, Oct 2026: page lines, rows and units. English only.
  'booking.line.rules': { en: 'How customers book, change and arrive.', az: '', ru: '' },
  'booking.line.branches': { en: 'Online booking at {branch}.', az: '', ru: '' },
  'booking.unit.min': { en: 'min', az: '', ru: '' },
  'booking.unit.h': { en: 'h', az: '', ru: '' },
  'booking.unit.days': { en: 'days', az: '', ru: '' },
  'booking.rules.limits': { en: 'Limits', az: '', ru: '' },
  'booking.rules.maxOpenLine': { en: 'Bookings one phone or e-mail may hold.', az: '', ru: '' },
  'booking.rules.maxHoldsLine': { en: 'Unconfirmed holds one API key may keep.', az: '', ru: '' },
  'booking.rules.arrival': { en: 'Check-in window', az: '', ru: '' },
  'booking.rules.arrivalLine': { en: 'When a booked customer may check in.', az: '', ru: '' },
  'booking.rules.early': { en: 'Early check-in', az: '', ru: '' },
  'booking.rules.earlyLine': { en: 'How long before the slot.', az: '', ru: '' },
  'booking.rules.onTime': { en: 'On time', az: '', ru: '' },
  'booking.rules.onTimeLine': { en: 'Either side of the slot.', az: '', ru: '' },
  'booking.rules.late': { en: 'Late check-in', az: '', ru: '' },
  'booking.rules.lateLine': { en: 'How long after the slot.', az: '', ru: '' },
  'booking.rules.bookedFirstLine': { en: 'Called before walk-ins.', az: '', ru: '' },
  'booking.rules.customerLine': { en: 'Changes, cancels and no-shows.', az: '', ru: '' },
  'booking.rules.changeUntil': { en: 'Change or cancel until', az: '', ru: '' },
  'booking.rules.changeUntilLine': { en: 'Hours before the slot.', az: '', ru: '' },
  'booking.rules.noShowLine': { en: 'Missed bookings before a block.', az: '', ru: '' },
  'booking.rules.noShowOffLine': { en: '0: never blocked.', az: '', ru: '' },
  'booking.rules.noShowDays': { en: 'Counted over', az: '', ru: '' },
  'booking.rules.noShowBlock': { en: 'Blocked for', az: '', ru: '' },
  'booking.rules.reminders': { en: 'Reminders', az: '', ru: '' },
  'booking.rules.remindEveningLine': { en: 'The day before, at a set time.', az: '', ru: '' },
  'booking.rules.sendAt': { en: 'Send at', az: '', ru: '' },
  'booking.rules.remindBefore': { en: 'Shortly before', az: '', ru: '' },
  'booking.rules.remindBeforeLine': { en: 'On the day, before the slot.', az: '', ru: '' },
  'booking.rules.before': { en: 'Before the slot', az: '', ru: '' },
  'booking.rules.pages': { en: 'Pages', az: '', ru: '' },
  'booking.rules.manageUrlLine': { en: 'Where customers change a booking.', az: '', ru: '' },
  'booking.rules.testPageLine': { en: 'A booking page to try it out.', az: '', ru: '' },
  'booking.rules.testLink': { en: 'Test link', az: '', ru: '' },
  'booking.rules.fieldsLine': { en: 'What the booking form asks.', az: '', ru: '' },
  'booking.br.takes': { en: 'Book online here', az: '', ru: '' },
  'booking.br.settingsLine': { en: 'Whether and how far ahead customers book.', az: '', ru: '' },
  'booking.br.daysAhead': { en: 'Days ahead', az: '', ru: '' },
  'booking.br.notice': { en: 'Minimum notice', az: '', ru: '' },
  'booking.br.hoursLine': { en: 'When slots are offered.', az: '', ru: '' },
  'booking.br.servicesLine': { en: 'Slots and limits per service.', az: '', ru: '' },
  'booking.br.onlineCount': { en: '{n} of {of} online', az: '', ru: '' },
  'booking.br.slot': { en: 'Slot length', az: '', ru: '' },
  'booking.br.closedLine': { en: 'Days nobody can book.', az: '', ru: '' },
  'booking.br.statServices': { en: 'Services', az: '', ru: '' },
  'booking.br.statAhead': { en: 'Days ahead', az: '', ru: '' },
  'booking.br.statClosed': { en: 'Closed', az: '', ru: '' },

  'booking.group': { en: 'Online booking', az: 'Onlayn növbə', ru: 'Онлайн-запись' },
  'booking.section.branches': { en: 'Booking branches', az: 'Filiallar', ru: 'Отделения' },
  'booking.section.rules': { en: 'Rules', az: 'Qaydalar', ru: 'Правила' },
  'booking.section.keys': { en: 'API keys', az: 'API açarları', ru: 'API-ключи' },
  'booking.also.branches': { en: 'slots capacity holidays hours limits', az: 'slotlar tutum bayramlar', ru: 'слоты вместимость праздники' },
  'booking.also.rules': { en: 'FIN reminders test page fields no-shows', az: 'FİN xatırlatmalar test səhifəsi', ru: 'ФИН напоминания тестовая страница' },
  'booking.also.keys': { en: 'website app call centre', az: 'sayt tətbiq çağrı mərkəzi', ru: 'сайт приложение колл-центр' },
  'booking.noHours': { en: 'No opening hours: nothing to book.', az: '', ru: '' },
  'booking.setHours': { en: 'Set hours', az: '', ru: '' },
  'booking.noSeat': { en: 'No licence seat', az: 'Lisenziya yeri yoxdur', ru: 'Нет места в лицензии' },
  'booking.daysAhead': { en: 'Days ahead', az: 'Neçə gün irəli', ru: 'Дней вперёд' },
  'booking.notice': { en: 'Minimum notice, min', az: 'Ən azı neçə dəq. əvvəl', ru: 'Минимум заранее, мин' },
  'booking.address': { en: 'Address', az: 'Ünvan', ru: 'Адрес' },
  'booking.services': { en: 'Services', az: 'Xidmətlər', ru: 'Услуги' },
  'booking.service': { en: 'Service', az: 'Xidmət', ru: 'Услуга' },
  'booking.online': { en: 'Online', az: 'Onlayn', ru: 'Онлайн' },
  'booking.slotMin': { en: 'Slot, min', az: 'Slot, dəq', ru: 'Слот, мин' },
  'booking.perSlot': { en: 'Per slot', az: 'Bir slota', ru: 'На слот' },
  'booking.notRouted': { en: 'Not routed here', az: 'Bura yönləndirilməyib', ru: 'Сюда не направляется' },
  'booking.closed': { en: 'Closed dates', az: 'Bağlı günlər', ru: 'Нерабочие дни' },
  'booking.closedLabel': { en: 'Label', az: 'Ad', ru: 'Название' },
  'booking.closedBooked': { en: '{n} booked', az: '{n} bron', ru: 'записей: {n}' },
  'booking.addDate': { en: 'Add date', az: 'Gün əlavə et', ru: 'Добавить день' },
  'booking.fin': { en: 'FIN', az: 'FİN', ru: 'ФИН' },
  'booking.fin.off': { en: 'Off', az: 'Söndürülüb', ru: 'Выкл.' },
  'booking.fin.optional': { en: 'Optional', az: 'İstəyə görə', ru: 'Необязательно' },
  'booking.fin.required': { en: 'Required', az: 'Mütləq', ru: 'Обязательно' },
  'booking.remindEvening': { en: 'Evening before', az: 'Bir gün əvvəl axşam', ru: 'Накануне вечером' },
  'booking.remindBefore': { en: 'Before, min', az: 'Əvvəl, dəq', ru: 'Заранее, мин' },
  'booking.maxOpen': { en: 'Open per contact', az: 'Əlaqə üzrə açıq', ru: 'Открытых на контакт' },
  'booking.maxHolds': { en: 'Unconfirmed per key', az: 'Açar üzrə təsdiqlənməmiş', ru: 'Неподтверждённых на ключ' },
  'booking.checkInEarly': { en: 'Early check-in, min', az: '', ru: '' },
  'booking.onTime': { en: 'On time ±, min', az: '', ru: '' },
  'booking.checkInLate': { en: 'Late check-in, min', az: '', ru: '' },
  'booking.bookedFirst': { en: 'Booked customers first', az: '', ru: '' },
  'booking.manageUrl': { en: 'Manage page', az: 'İdarəetmə səhifəsi', ru: 'Страница управления' },
  'booking.testPage': { en: 'Test page', az: 'Test səhifəsi', ru: 'Тестовая страница' },
  'booking.testPageUntil': { en: 'Open until {date}', az: '{date} tarixinədək açıq', ru: 'Открыта до {date}' },
  'booking.locked': {
    en: 'Licence locked: only switching off, deleting, or closing the test page.',
    az: 'Lisenziya bloklanıb: yalnız söndürmə, silmə, test səhifəsini bağlama.',
    ru: 'Лицензия заблокирована: только выключение, удаление, закрытие тестовой страницы.',
  },
  'booking.key.trusted': { en: 'Trusted', az: 'Etibarlı', ru: 'Доверенный' },
  'booking.key.needsCode': { en: 'Needs code', az: 'Kod tələb edir', ru: 'Нужен код' },
  'booking.key.rate': { en: 'Per minute', az: 'Dəqiqədə', ru: 'В минуту' },
  'booking.key.lastUsed': { en: 'Last used', az: 'Son istifadə', ru: 'Последнее использование' },
  'booking.key.never': { en: 'Never', az: 'Heç vaxt', ru: 'Никогда' },
  'booking.key.active': { en: 'State', az: 'Vəziyyət', ru: 'Состояние' },
  'booking.key.on': { en: 'On', az: 'Aktiv', ru: 'Вкл.' },
  'booking.key.off': { en: 'Off', az: 'Deaktiv', ru: 'Выкл.' },
  'booking.key.create': { en: 'New key', az: 'Yeni açar', ru: 'Новый ключ' },
  'booking.key.shownOnce': { en: 'Shown once', az: 'Bir dəfə göstərilir', ru: 'Показан один раз' },
  'booking.key.copy': { en: 'Copy', az: 'Kopyala', ru: 'Копировать' },
  'booking.key.deleteAsk': { en: 'Delete {name}? Calls with it stop.', az: '{name} silinsin? Bu açarla sorğular dayanacaq.', ru: 'Удалить {name}? Запросы с этим ключом прекратятся.' },
  'booking.key.none': { en: 'No keys', az: 'Açar yoxdur', ru: 'Ключей нет' },
  'booking.problem.daysAhead': { en: 'Days ahead: 1–90', az: 'Neçə gün irəli: 1–90', ru: 'Дней вперёд: 1–90' },
  'booking.problem.notice': { en: 'Minimum notice: 0–1440', az: 'Ən azı neçə dəq. əvvəl: 0–1440', ru: 'Минимум заранее: 0–1440' },
  'booking.problem.slot': { en: 'Slot: 5–240 min', az: 'Slot: 5–240 dəq', ru: 'Слот: 5–240 мин' },
  'booking.problem.perSlot': { en: 'Per slot: 1–50', az: 'Bir slota: 1–50', ru: 'На слот: 1–50' },
  'booking.problem.maxOpen': { en: 'Open per contact: 1–10', az: 'Əlaqə üzrə açıq: 1–10', ru: 'Открытых на контакт: 1–10' },
  'booking.problem.maxHolds': { en: 'Unconfirmed per key: 1–500', az: 'Açar üzrə təsdiqlənməmiş: 1–500', ru: 'Неподтверждённых на ключ: 1–500' },
  'booking.problem.before': { en: 'Before: 5–1440 min', az: 'Əvvəl: 5–1440 dəq', ru: 'Заранее: 5–1440 мин' },
  'booking.problem.onTime': { en: 'On time: 0–240 min', az: '', ru: '' },
  'booking.problem.checkInEarly': { en: 'Early check-in: on time–240 min', az: '', ru: '' },
  'booking.problem.checkInLate': { en: 'Late check-in: on time–240 min', az: '', ru: '' },
  'booking.problem.manageUrl': { en: 'https://… {token}', az: 'https://… {token}', ru: 'https://… {token}' },
  'booking.problem.hours': { en: 'Booking hours: ranges that do not overlap', az: '', ru: '' },
  'booking.problem.weekdays': { en: 'Choose at least one day', az: '', ru: '' },
  'booking.problem.dailyMax': { en: 'Per day: 1–5000, or empty', az: '', ru: '' },
  'booking.problem.changeUntil': { en: 'Changes until: 0–168 h', az: '', ru: '' },
  'booking.problem.noShow': { en: 'No-shows: 0–20 in 1–365 days', az: '', ru: '' },
  'booking.problem.contactField': { en: 'Ask mobile or e-mail', az: '', ru: '' },
  // Booking hours, service limits, customer rules and fields (30 Oct 2026).
  'booking.hours': { en: 'Booking hours', az: '', ru: '' },
  'booking.ownHours': { en: 'Own booking hours', az: '', ru: '' },
  'booking.followsOpening': { en: 'Follows opening hours', az: '', ru: '' },
  'booking.addRange': { en: 'Add hours, {day}', az: '', ru: '' },
  'booking.weekdays': { en: 'Days', az: '', ru: '' },
  'booking.dailyMax': { en: 'Per day', az: '', ru: '' },
  'booking.noCap': { en: 'Any', az: '', ru: '' },
  'booking.customerRules': { en: 'Customer rules', az: '', ru: '' },
  'booking.changeUntil': { en: 'Changes until, h before', az: '', ru: '' },
  'booking.changeUntilNotice': { en: 'Minimum notice', az: '', ru: '' },
  'booking.noShowLimit': { en: 'No-shows to block', az: '', ru: '' },
  'booking.noShowOff': { en: 'Off', az: '', ru: '' },
  'booking.noShowDays': { en: 'Within, days', az: '', ru: '' },
  'booking.noShowBlock': { en: 'Block, days', az: '', ru: '' },
  'booking.fields': { en: 'Customer fields', az: '', ru: '' },
  'booking.mobile': { en: 'Mobile', az: '', ru: '' },
  'booking.problem.keyName': { en: 'Name: 1–80 characters', az: 'Ad: 1–80 simvol', ru: 'Название: 1–80 символов' },
  'booking.problem.rate': { en: 'Per minute: 1–6000', az: 'Dəqiqədə: 1–6000', ru: 'В минуту: 1–6000' },
  // Reception's Book and the Appointments screen.
  'booking.book': { en: 'Book', az: 'Bron et', ru: 'Записать' },
  'booking.day': { en: 'Day', az: 'Gün', ru: 'День' },
  'booking.slot': { en: 'Time', az: 'Vaxt', ru: 'Время' },
  'booking.noSlots': { en: 'No free time', az: 'Boş vaxt yoxdur', ru: 'Нет свободного времени' },
  'booking.name': { en: 'Name', az: 'Ad, soyad', ru: 'Имя' },
  'booking.channel.sms': { en: 'SMS', az: 'SMS', ru: 'SMS' },
  'booking.channel.email': { en: 'E-mail', az: 'E-poçt', ru: 'Эл. почта' },
  'booking.contact.sms': { en: 'Phone', az: 'Telefon', ru: 'Телефон' },
  'booking.contact.email': { en: 'E-mail', az: 'E-poçt', ru: 'Эл. почта' },
  'booking.language': { en: 'Language', az: 'Dil', ru: 'Язык' },
  'booking.noChannel': { en: 'No SMS or e-mail set up', az: '', ru: '' },
  'booking.booked': { en: 'Booked: {code}', az: 'Bron edildi: {code}', ru: 'Записано: {code}' },
  'booking.move': { en: 'Move', az: 'Köçür', ru: 'Перенести' },
  'booking.moved': { en: 'Moved to {time}', az: '{time} vaxtına köçürüldü', ru: 'Перенесено на {time}' },
  'booking.source.online': { en: 'Online', az: 'Onlayn', ru: 'Онлайн' },
  'booking.source.reception': { en: 'Reception', az: 'Qəbul', ru: 'Ресепшн' },
  'booking.dayLoad': { en: '{booked} of {offered} booked', az: '{offered} yerdən {booked} bron', ru: 'записано {booked} из {offered}' },
  'booking.problem.name': { en: 'Name: 1–100 characters', az: 'Ad: 1–100 simvol', ru: 'Имя: 1–100 символов' },
  'booking.problem.fin': { en: 'FIN: 7 letters and digits', az: 'FİN: 7 hərf və rəqəm', ru: 'ФИН: 7 букв и цифр' },
  'booking.problem.contact': { en: 'Check the contact', az: 'Əlaqə məlumatını yoxlayın', ru: 'Проверьте контакты' },
  'booking.problem.required': { en: 'Fill in {field}', az: '', ru: '' },
  'booking.problem.shape': { en: 'Check {field}', az: '', ru: '' },
  'booking.optional': { en: 'optional', az: '', ru: '' },
  'booking.codeLine': { en: 'code {code}', az: 'kod {code}', ru: 'код {code}' },
  'booking.sourceLabel': { en: 'Source', az: 'Mənbə', ru: 'Источник' },
} satisfies Record<`booking.${string}`, Phrase>
